import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import profileUser from '../../../../../assets/images/hotelDetailsOverlay/profile-user.png';
import { getFullName } from '../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/utils/getFullName.js';
import { Flex, LabelXSmallBold } from '../../../../../primitives/index.js';
export const UserName = ({
  firstName,
  lastName
}) => {
  return _jsxs(Flex, {
    alignItems: "center",
    direction: "row",
    spacing: "8px",
    children: [_jsx("img", {
      src: profileUser,
      width: 24,
      height: 24,
      alt: ""
    }), _jsx(LabelXSmallBold, {
      children: getFullName({
        firstName,
        lastName
      })
    })]
  });
};